export const FW = {
  400: 400,
  600: 600,
}
